import { UPDATE_USER } from "./actionTypes";
import { UPDATE_RESTAURANT } from "./actionTypes";
import { UPDATE_ATTRIBUTES } from "./actionTypes";
import { UPDATE_TOKENS } from "./actionTypes";
import { UPDATE_RESTAURANT_STATISTICS } from "./actionTypes";
import { UPDATE_USERS_STATISTICS } from "./actionTypes";
import { UPDATE_LANGUAGE } from "./actionTypes";
import { UPDATE_FIRST_RESTAURANT } from "./actionTypes";

export function updateUserData(userData) {
  return {
    type: UPDATE_USER,
    payload: userData
  };
}

export function updateRestaurant(restaurant) {
  return {
    type: UPDATE_RESTAURANT,
    payload: restaurant
  };
}

export function updateAttributes(attributes) {
  return {
    type: UPDATE_ATTRIBUTES,
    payload: attributes
  };
}

export function updateTokens(tokens) {
  return {
    type: UPDATE_TOKENS,
    payload: tokens
  };
}

export function updateRestaurantStatistics(restaurantStatistics) {
  return {
    type: UPDATE_RESTAURANT_STATISTICS,
    payload: restaurantStatistics
  };
}

export function updateUsersStatistics(usersStatistics) {
  return {
    type: UPDATE_USERS_STATISTICS,
    payload: usersStatistics
  };
}

export function updateLanguage(language) {
  return {
    type: UPDATE_LANGUAGE,
    payload: language
  };
}

export function updateFirstRestaurant(restaurant) {
  return {
    type: UPDATE_FIRST_RESTAURANT,
    payload: restaurant
  };
}



// WEBPACK FOOTER //
// ./src/actions/actions.js